import Ajv, { type JSONSchemaType } from "ajv";
import addFormats from "ajv-formats";

const ajv = new Ajv();
addFormats(ajv);

export type HotelRawData = {
  hotel_id: number;
  hotel_name: string;
  currency_code: string;
  urgency_message?: string;
  url: string;
  accommodation_type_name: string;
  review_score: string | number;
  min_total_price: number;
  review_recommendation?: string;
  review_score_word?: string;
  review_nr?: number;
  id: string;
  max_1440_photo_url: string;
};

// Function to map full data to HotelRawData properties
export function mapToHotelRawData(
  hotelRawData: Partial<HotelRawData>,
): HotelRawData {
  return {
    hotel_id: hotelRawData.hotel_id ?? 0,
    hotel_name: hotelRawData.hotel_name ?? "",
    currency_code: hotelRawData.currency_code ?? "",
    urgency_message: hotelRawData.urgency_message ?? "",
    url: hotelRawData.url ?? "",
    review_nr: hotelRawData.review_nr ?? 0,
    accommodation_type_name: hotelRawData.accommodation_type_name ?? "",
    review_score: hotelRawData.review_score ?? "",
    min_total_price: hotelRawData.min_total_price ?? 0,
    review_recommendation: hotelRawData.review_recommendation ?? "",
    review_score_word: hotelRawData.review_score_word ?? "",
    id: hotelRawData.id ?? "",
    max_1440_photo_url: hotelRawData.max_1440_photo_url ?? "",
  };
}

const hotelSchema: JSONSchemaType<HotelRawData> = {
  type: "object",
  properties: {
    hotel_id: { type: "integer" },
    hotel_name: { type: "string" },
    currency_code: { type: "string" },
    urgency_message: { type: "string", nullable: true },
    url: { type: "string", format: "uri" },
    accommodation_type_name: { type: "string" },
    review_score: { oneOf: [{ type: "string" }, { type: "number" }] },
    min_total_price: { type: "number" },
    review_recommendation: { type: "string", nullable: true },
    review_score_word: { type: "string", nullable: true },
    review_nr: { type: "number", nullable: true },
    id: { type: "string" },
    max_1440_photo_url: { type: "string", format: "uri" },
  },
  required: [
    "hotel_id",
    "hotel_name",
    "currency_code",
    "url",
    "accommodation_type_name",
    "review_score",
    "min_total_price",
    "id",
    "max_1440_photo_url",
  ],
};
// validate is a type guard for HotelRawData - type is inferred from schema type
const validateHotel = ajv.compile(hotelSchema);

export const isValidHotelData = (data: unknown): data is HotelRawData => {
  if (validateHotel(data)) {
    return true;
  }

  console.error("Invalid data", validateHotel.errors);
  return false;
};
